import React, { Suspense } from "react";
import { BrowserRouter } from "react-router";
import AppRoutes from "./routes/AppRoutes";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import theme from "./style/theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "./style/App.css";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 دقیقه
        gcTime: 10 * 60 * 1000, // 10 دقیقه
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
      },
    },
  });

  return (
    <div className="App">
      <BrowserRouter>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <QueryClientProvider client={queryClient}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <Suspense fallback={<div>در حال بارگذاری...</div>}></Suspense>
                <ToastContainer
                  position="top-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="dark"
                />
                <AppRoutes />
              </ThemeProvider>
            </StyledEngineProvider>
          </QueryClientProvider>
        </LocalizationProvider>
      </BrowserRouter>
    </div>
  );
}
export default App;
